import React from 'react';
import PropTypes from 'prop-types';
import { Radio, RadioGroup } from '@ferris/react/components/forms';
import { Label } from './PDField';

const RadioGroupComponent = ({
    labelProps,
    groupName,
    onChange,
    selectedValue,
    yesLabel,
    noLabel,
    yesId,
    noId
}) => (
    <div className="property_details__radio">
        <div className="property_details__question">
            { labelProps && (<Label {...labelProps} />)}
        </div>
        <RadioGroup
            groupName={groupName}
            onChange={onChange}
            selectedValue={selectedValue}
        >
            <Radio
                label={yesLabel}
                value="yes"
                checked={selectedValue === 'yes'}
                formControlProps={{ id: yesId }}
            />
            <Radio
                label={noLabel}
                value="no"
                checked={selectedValue === 'no'}
                formControlProps={{ id: noId }}
            />
        </RadioGroup>
    </div>
);

RadioGroupComponent.propTypes = {
    labelProps: Label.propTypes.isRequired,
    groupName: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
    yesLabel: PropTypes.string.isRequired,
    noLabel: PropTypes.string.isRequired,
    yesId: PropTypes.string.isRequired,
    noId: PropTypes.string.isRequired
};

export default RadioGroupComponent;
